/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    const bodyData = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2024-02-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    }

    const request = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      options,
    )

    if (!request.ok) {
      console.error(request)
      this.throwError()
    } else {
      this.showSuccess()
    }
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    const emailAddress = this.els.email.element.value

    this.KlaviyoSubmission(variantId, emailAddress)
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
